import { render, staticRenderFns } from "./FreeParkingSpaces.vue?vue&type=template&id=39bc8942&"
import script from "./FreeParkingSpaces.vue?vue&type=script&lang=ts&"
export * from "./FreeParkingSpaces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VProgressCircular})
